import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const materialFormSchema = z
  .object({
    _id: z.string().optional(),
    name: z.string().min(1, 'Nome é obrigatório'),
    description: z
      .string()
      .max(500, 'A descrição deve ter no máximo 500 caracteres')
      .optional(),
    liberationDate: z.date(),
    liberationTime: z.string().min(1, 'Horário é obrigatório'),

    feedImagesFiles: z.array(z.custom<File>()),
    storyImagesFiles: z.array(z.custom<File>()),
    youtubeImagesFiles: z.array(z.custom<File>()),
    isSellersApp: z.boolean().default(false),
    isTeamsApp: z.boolean().default(false),
  })
  .refine(
    (data) => {
      const hasImages =
        data.feedImagesFiles.length > 0 ||
        data.storyImagesFiles.length > 0 ||
        data.youtubeImagesFiles.length > 0

      return hasImages
    },
    {
      message: 'Pelo menos uma imagem é obrigatória',
      path: ['feedImagesFiles', 'storyImagesFiles', 'youtubeImagesFiles'],
    },
  )

export type MaterialFormValues = z.infer<typeof materialFormSchema>

const initialData: MaterialFormValues = {
  name: '',
  description: '',
  liberationDate: new Date(),
  liberationTime: '12:00',
  feedImagesFiles: [],
  storyImagesFiles: [],
  youtubeImagesFiles: [],
  isSellersApp: false,
  isTeamsApp: false,
}

interface UseMaterialFormProps {
  getDefaultValues?: () => Promise<MaterialFormValues>
}

export const useMaterialForm = ({ getDefaultValues }: UseMaterialFormProps) => {
  return useForm<MaterialFormValues>({
    defaultValues: async () => {
      if (getDefaultValues) {
        return await getDefaultValues()
      }
      return initialData
    },
    resolver: zodResolver(materialFormSchema),
  })
}
